import { getViewportCategory } from "../../../../layout/selectors";
import { SMALL_VIEWPORT } from "../../../../layout/constants";

export const isLargeMediumViewPort = (state) =>
  getViewportCategory(state) !== SMALL_VIEWPORT;
